import CmDeliveryNoteNumber from './CmDeliveryNoteNumber';
import CompletedDate from './CompletedDate';
import Created from './Created';
import CreatorUser from './CreatorUser';
import Customer from './Customer';
import GrossPrice from './GrossPrice';
import Id from './Id';
import IsStockist from './IsStockist';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import Status from './Status';
import Storage from './Storage';
import Supplier from './Supplier';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev száma',
  Status: 'Státusz',
  Supplier: 'Szállító',
  Customer: 'Átvevő',
  Storage: 'Raktár',
  CompletedDate: 'Teljesítés dátuma',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  IsStockist: 'Besz. ár végleges'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}, {
  value: 'IsStockist',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Status',
}, {
  value: 'Customer',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}, {
  value: 'IsStockist',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Customer,
  Supplier,
  Storage,
  CompletedDate,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Created,
  Updated,
  IsStockist,
};
